module.exports = __webpack_public_path__ + "img/Rich_Morris@3x.d51055c6.webp";